import { render, staticRenderFns } from "./log-card.vue?vue&type=template&id=1256ef1c&"
import script from "./log-card.vue?vue&type=script&lang=js&"
export * from "./log-card.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports